const FontStyle = (t) => ([
	{ value: '0', label: t('product_section.strings.style_normal') },
	{ value: '1', label: t('product_section.strings.style_bold') },
	{ value: '2', label: t('product_section.strings.style_cursive') },
	{ value: '3', label: t('product_section.strings.style_bold_cursive') }
])

export default FontStyle
